<span class="text-sm text-gray" *ngIf="range$ | async"
  >{{ from }} <span *ngIf="to">- {{ to }}</span></span
>
